import React from 'react'
import LoginRegistration from '../components/Registration/LoginRegistration'

export default class Login extends React.Component<{}> {
    render() {
        return <LoginRegistration type="login" />
    }
}
